import { FormattedMessage } from 'react-intl';
import { Spinner } from './core/Spinner';

export const Loading = () => {
  return (
    <div className="flex grow justify-center p-8" aria-busy="true">
      <div
        className="flex size-full items-center justify-center"
        role="status"
        aria-live="polite"
      >
        <Spinner />
        <span className="sr-only">
          <FormattedMessage defaultMessage="Laddar innehåll" />
        </span>
      </div>
    </div>
  );
};
